var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43788 0.424071C8.44568 0.423926 8.45349 0.423926 8.4613 0.424071H9.07463V1.04907L9.07463 7.95057C9.07463 8.29575 8.79481 8.57557 8.44963 8.57557C8.10445 8.57557 7.82463 8.29575 7.82463 7.95057L7.82463 2.55829L1.99236 8.39259C1.74832 8.63671 1.35267 8.63671 1.10863 8.39259C0.864595 8.14847 0.864596 7.75268 1.10863 7.50856L6.94108 1.67407L1.55054 1.67407C1.20536 1.67407 0.925537 1.39425 0.925537 1.04907C0.925537 0.703893 1.20536 0.424071 1.55054 0.424071L8.43788 0.424071Z",
    fill: "#086DE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlue);
export default __webpack_public_path__ + "static/media/arrow_up_blue.a18bff43a1f933930304857a479ca34d.svg";
export { ForwardRef as ReactComponent };